<section *ngFor="let input of inputs" class="ion-padding-bottom">
    <ion-label>
        <ion-skeleton-text animated style="width: 40%; height: 18px"></ion-skeleton-text>
    </ion-label>
    <div>
        <ion-skeleton-text animated style="width: 100%; height: 40px"></ion-skeleton-text>
    </div>
</section>
